'use strict';


exports.SD = require('./SD');
exports.NMR = require('./NMR');
exports.NMR2D = require('./NMR2D');
exports.ACS = require('./AcsParser');
exports.JAnalyzer = require('./JAnalyzer');
//exports.SD2 = require('/SD2');


/*****************
 ** WEBPACK FOOTER
 ** ./~/spectra-data/src/index.js
 ** module id = 2
 ** module chunks = 0
 **/